// @flow
import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";

import { NavbarMenuItem } from "imagus-components";
import UserAuth from "../containers/UserAuth";

type AuthedNavbarMenuItemPropType = {
  location: *,
  auth?: Array<string>,
  to?: string
};

class AuthedNavbarMenuItem extends Component<*, AuthedNavbarMenuItemPropType> {
  render(): React$Element<*> {
    const { auth, to, ...other } = this.props;
    const pathname = this.props.location.pathname;

    if (auth) {
      if (to) {
        return (
          <UserAuth oneOfPrincipalList={auth}>
            <Link to={to}>
              <NavbarMenuItem selected={pathname == to} {...other} />
            </Link>
          </UserAuth>
        );
      } else {
        return (
          <UserAuth oneOfPrincipalList={auth}>
            <NavbarMenuItem selected={pathname == to} {...other} />
          </UserAuth>
        );
      }
    } else {
      if (to) {
        return (
          <Link to={to}>
            <NavbarMenuItem selected={pathname == to} {...other} />
          </Link>
        );
      } else {
        return <NavbarMenuItem selected={pathname == to} {...other} />;
      }
    }
  }
}

export default withRouter(AuthedNavbarMenuItem);
